<template>
  <div class="common-tab-box merge-city-job hot-job-box">
    <div class="box-title">热门企业</div>
    <el-card class="box-card" shadow="hover" v-for="(item, index) in hotCompany.slice(0, 9)" :key="index" :body-style="{ width: bodyWidth + 'px', padding: '0px', height: '380px', cursor: 'pointer' }">
      <div>
        <!-- 公司信息 -->
        <div class="company-info-top flex" @click="openCompany(item)">
          <img style="height: 44px; width: 44px; border-radius: 50%" :src="item.logo" />
          <div class="company-info">
            <div class="company-name" :style="{ 'max-width': bodyWidth - 100 + 'px' }">
              {{ item.companyname }}
            </div>
            <p>
              {{ item.district_cn }}
              <span class="vline"></span>
              {{ item.nature_cn }}
              <span class="vline"></span>
              {{ item.trade_cn }}
            </p>
          </div>
        </div>
        <!-- 职位列表 -->
        <ul class="company-job-list">
          <li class="company-job-item" v-for="(cItem, cIndex) in item.jobs.slice(0, 3)" :key="cIndex" @click="jobDetail(cItem)">
            <div class="job-info">
              <div class="job-info-top flexElm">
                <p class="name">{{ cItem.jobs_name }}</p>
                <p class="salary">{{ cItem.wage_cn || '面议' }}</p>
              </div>
              <p class="job-text">
                <span>{{ cItem.district_cn }}</span>
                <span>经验不限</span>
                <span>本科</span>
              </p>
            </div>
          </li>
        </ul>
        <p class="more-job-btn"><span class="btn btn-outline" @click="openCompany(item)">查看更多职位</span></p>
      </div>
    </el-card>
    <p class="common-tab-more"><span class="btn btn-outline" @click="seeMore">查看更多</span></p>
  </div>
</template>

<script>
export default {
  name: 'HotCompany',
  props: {
    minWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      hotCompany: []
    };
  },
  computed: {
    bodyWidth() {
      return (this.minWidth - 16 * 4) / 3;
    }
  },
  methods: {
    setData(data) {
      this.hotCompany = [];
      const _data = JSON.parse(JSON.stringify(data)) || [];
      _data.forEach((item) => {
        this.$set(item, 'logo', window.global.avatarUrl + 'avatars.php?&type=1&big=1&uid=' + item.uid);
      });
      this.hotCompany = _data;
    },
    // 查看更多职位
    openCompany(item) {
      this.$router.push({
        path: '/person/corp/corpDetail',
        query: {
          id: item.company_id
        }
      });
      // let routeUrl = this.$router.resolve({
      // 	path: '/person/corp/corpDetail',
      // 	query: {
      // 		id: item.company_id
      // 	}
      // })
      // window.open(routeUrl.href, '_blank')
    },
    //职位明细
    jobDetail(item) {
      this.$router.push({
        path: '/person/position/jobDetail',
        query: {
          id: item.id
        }
      });
      // let routeUrl = this.$router.resolve({
      // 	path: '/person/position/jobDetail',
      // 	query: {
      // 		id: item.id
      // 	}
      // })
      // window.open(routeUrl.href, '_blank')
    },
    //查看更多公司
    seeMore() {
      this.$router.push('/person/corp');
    }
  }
};
</script>

<style></style>
